import { render, staticRenderFns } from "./SettingsNotificationsForm.vue?vue&type=template&id=086aafc2&scoped=true&"
import script from "./SettingsNotificationsForm.vue?vue&type=script&lang=js&"
export * from "./SettingsNotificationsForm.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNotificationsForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SettingsNotificationsForm.vue?vue&type=style&index=1&id=086aafc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086aafc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCheckbox,VSwitch})
